module.exports = __webpack_public_path__ + "img/098_L.2f39f7bc.png";